import { IconWrapper } from '../runtime';
export default IconWrapper('pound', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48"
    }
  }, [h("g", {
    "attrs": {
      "stroke": "none",
      "stroke-width": props.strokeWidth,
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }, [h("g", {
    "attrs": {
      "transform": "translate(6.000000, 5.500000)",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }, [h("path", {
    "attrs": {
      "d": "M0,10.5 L36,10.5"
    }
  }), h("path", {
    "attrs": {
      "d": "M-8,18.5 L28,18.5",
      "transform": "translate(10.000000, 18.500000) rotate(90.000000) translate(-10.000000, -18.500000) "
    }
  }), h("path", {
    "attrs": {
      "d": "M8,18.5 L44,18.5",
      "transform": "translate(26.000000, 18.500000) rotate(90.000000) translate(-26.000000, -18.500000) "
    }
  }), h("path", {
    "attrs": {
      "d": "M0,26.5 L36,26.5"
    }
  })])])]);
});